module.exports = __webpack_public_path__ + "img/15.fb2217b8.jpg";